import React from 'react';


export function TableContent({headers, chapterIndex, tableIndex, format, children}) {

    return (
        <div className={"my-5 "} style={{overflowX:"scroll"}}>
            <table className={format.classes === "" ? "table table-light table-striped" : format.classes}>
                <thead>{headers}</thead>
                <tbody>{children}</tbody>
            </table>
            <p className={"text-muted text-center m-0 mt-3"}><strong>Tabell {chapterIndex+1}.{tableIndex}:</strong> {format.alt}</p>
        </div>

    );

}